import React from "react";
import { Avatar, Card, makeStyles } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import "./TeamCard.css";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
  },
  large: {
    width: theme.spacing(27),
    height: theme.spacing(27),
  },
}));

export default function TeamCard(props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className="team-main">
        <Card className={classes.root} style={{}}>
          <CardContent>
            <Avatar
              className={classes.large}
              style={{ marginBottom: "2%", margin: "auto" }}
              src={props.src}
              alt={props.avalt ?? "Name"}
            />

            <Typography variant="h4" component="h1" style={{ padding: "2%" }}>
              {props.name}
            </Typography>

            <Typography variant="body1" component="p" style={{ fontSize: 25 }}>
              {props.description}
            </Typography>
          </CardContent>
          <a href={props.linkedin} target="noopener noreferrer">
            <div style={{ marginBottom: "2%" }}>
              <LinkedInIcon fontSize="large" />
            </div>
          </a>
        </Card>
      </div>
    </React.Fragment>
  );
}
